import styled from 'styled-components';

export default function Button({
	onClick,
	id: buttonId,
	label,
	value,
	feature,
	animate = 'wiggle',
	animateDuration,
	flagLabel,
	backgroundColor,
	textColor,
}) {
	if (!label || !label.length || !value || !value.length) {
		return false;
	}

	function doOnClick(e) {
		onClick(e, buttonId);
	}

	return (
		<p className="container slp-Section slp-Button">
			<StyledButton
				href={value}
				onClick={doOnClick}
				target="_blank"
				rel="noopener noreferrer"
				title={label}
				className={`btn btn-block ${'animate' === feature ? animate : ''} ${
					'animate' === feature && 'forever' === animateDuration ? 'forever' : ''
				}`}
				backgroundColor={backgroundColor}
				textColor={textColor}
			>
				{label}
				{'flag' === feature && (
					<StyledFlag>
						{!flagLabel || '' === flagLabel ? (
							<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
								<path d="M12 .288l2.833 8.718H24l-7.417 5.389 2.833 8.718L12 17.725l-7.417 5.388 2.833-8.718L0 9.006h9.167z" />
							</svg>
						) : (
							<i>{flagLabel}</i>
						)}
					</StyledFlag>
				)}
			</StyledButton>
		</p>
	);
}

const StyledButton = styled.a`
	${(props) =>
		'' !== props.backgroundColor ? `background: rgb(${props.backgroundColor}) !important;` : ''}
	${(props) => ('' !== props.textColor ? `color: rgb(${props.textColor}) !important;` : '')}
	position: relative;
`;

const StyledFlag = styled.span`
	position: absolute;
	right: -0.618rem;
	top: -0.618rem;
	transform: rotate(8deg);

	i {
		background: gold;
		border-radius: 0.382rem;
		color: black;
		font-size: 0.82rem;
		padding: 0.236rem 0.618rem;
	}

	svg {
		fill: gold !important;
		margin-right: 0.5rem;
		margin-top: -0.5rem;
	}
`;
